import type { InputHTMLAttributes } from 'react';

export function Input(props: InputHTMLAttributes<HTMLInputElement>) {
  const { className = '', ...rest } = props;
  return (
    <input
      className={
        'w-full rounded-md border border-[var(--co-border)] bg-[var(--co-surface)] ' +
        'px-3 py-2 text-sm placeholder:text-[var(--co-muted)] ' +
        'focus:outline-none focus:ring-2 focus:ring-[var(--co-brand)] ' +
        className
      }
      {...rest}
    />
  );
}
